import { Provider } from "./language.provider"

const LanguageProvider = Provider

export { LanguageProvider }